// Furniture
import Table from './furniture/Table'

// Props
// import CardboardBox from './props/CardboardBox'
import PhotoOnWall from './props/PhotoOnWall.jsx'
// import PhotoOnTable from './props/PhotoOnTable.jsx'
// import PhotoOnFloor from './props/PhotoOnFloor.jsx'

// Electro
import DeskLamp from './electro/DeskLamp'
import Television from './electro/Television'

// Tools
import HandSaw from './tools/HandSaw'
import ScrewDriver from './tools/ScrewDriver'
import CassettePlayer from './electro/CassettePlayer.jsx'
import Pipes from './props/Pipes.jsx'

// Weapons
// import BaseballBat from './weapons/BaseballBat'
// import ToolWall from './tools/ToolWall'


export default function Furniture()
{
    return <>

        {/* Furniture */}
        <Table />

        {/* Electro */}
        <DeskLamp />
        <Television />
        <CassettePlayer />

        {/* Tools */}
        <HandSaw />
        <ScrewDriver />
        {/* <ToolWall /> */}

        {/* Weapons */}
        {/* <BaseballBat /> */}

        {/* Props */}
        {/* <CardboardBox /> */}
        <PhotoOnWall />
        {/* <PhotoOnFloor /> */}
        {/* <PhotoOnTable /> */}
        <Pipes />

    </>
}